import { postBiz, json } from '../core/coreapi';
import { GovernanceWorkbench, ApiEnvelope } from './CAGovernanceTypes';

const unwrap = async <T,>(promise: Promise<any>): Promise<T> => {
  const response: ApiEnvelope<T> | T = await json(promise);
  if (response && typeof response === 'object' && 'rc' in response) {
    const envelope = response as ApiEnvelope<T>;
    if (Number(envelope.rc) !== 0) throw new Error(envelope.em || `Governance request failed (rc=${envelope.rc})`);
    if (envelope.sd == null) throw new Error('Governance returned no data.');
    return envelope.sd;
  }
  // Some existing coreapi.json implementations already unwrap {rc,sd}.
  return response as T;
};

export const fetchGovernanceWorkbench = (pci: number) =>
  unwrap<GovernanceWorkbench>(postBiz({ s: 'cagovernance', a: 'workbench', pci }));
export const ensureGovernancePackage = (pci: number) =>
  unwrap<any>(postBiz({ s: 'cagovernance', a: 'ensurepackage', pci }));
export const acknowledgeGovernanceValidation = (pci: number) =>
  unwrap<any>(postBiz({ s: 'cagovernance', a: 'acknowledgevalidation', pci }));
export const acknowledgeGovernancePpm = (pci: number) =>
  unwrap<any>(postBiz({ s: 'cagovernance', a: 'acknowledgeppm', pci }));
